import { render } from "./ReferencePopup.vue?vue&type=template&id=7a464f0d&scoped=true"
import script from "./ReferencePopup.vue?vue&type=script&lang=js"
export * from "./ReferencePopup.vue?vue&type=script&lang=js"

import "./ReferencePopup.vue?vue&type=style&index=0&id=7a464f0d&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a464f0d"]])

export default __exports__